import AbstractService from "./AbstractService";

class ExpeditionDealerService extends AbstractService {

  static _getUrl(partUrl) {
    return `${super._getUrl()}/expedition${partUrl}`;
  }

  static async getExpeditionsFlags() {

    const url = this._getUrl(`/get-expeditions-flags`);
    const resp = await this._getResource(url);

    return {
      data: resp.results
    };
  }

  static async getExpeditionsBremenRotterdamList(params) {
    const { pageSize, urlParam } = this._getPageSizeUrlParamList(params);
    const url = this._getUrl(`/get-expeditions-bremen-rotterdam${urlParam}`);
    const resp = await this._getResource(url);
    return {
      pageSize: pageSize,
      totalCount: resp.count,
      data: resp.results
    };
  }

  static async getAdditionalInfoExpeditionsBremenRotterdam(itemId) {
    const url = this._getUrl(`/${itemId}/get-additional-info-bremen-rotterdam`);
    const resp = await this._getResource(url);
    return {
      data: resp.results
    };
  }


  static async getExpeditionsBremenRotterdamPolandList(params) {
    const { pageSize, urlParam } = this._getPageSizeUrlParamList(params);
    const url = this._getUrl(`/get-expeditions-bremen-rotterdam-poland${urlParam}`);
    const resp = await this._getResource(url);
    return {
      pageSize: pageSize,
      totalCount: resp.count,
      data: resp.results
    };
  }
  static async getAdditionalInfoExpeditionsBremenRotterdamPoland(itemId) {
    const url = this._getUrl(`/${itemId}/get-additional-info-bremen-rotterdam-poland`);
    const resp = await this._getResource(url);
    return {
      data: resp.results
    };
  }

  static async getExpeditionsBremenRotterdamCzechList(params) {
    const { pageSize, urlParam } = this._getPageSizeUrlParamList(params);
    const url = this._getUrl(`/get-expeditions-bremen-rotterdam-czech${urlParam}`);
    const resp = await this._getResource(url);
    return {
      pageSize: pageSize,
      totalCount: resp.count,
      data: resp.results
    };
  }
  static async getAdditionalInfoExpeditionsBremenRotterdamCzech(itemId) {
    const url = this._getUrl(`/${itemId}/get-additional-info-bremen-rotterdam-czech`);
    const resp = await this._getResource(url);
    return {
      data: resp.results
    };
  }




  static async getExpeditionsPotiList(params) {
    const { pageSize, urlParam } = this._getPageSizeUrlParamList(params);
    const url = this._getUrl(`/get-expeditions-poti${urlParam}`);
    const resp = await this._getResource(url);
    return {
      pageSize: pageSize,
      totalCount: resp.count,
      data: resp.results
    };
  }

  static async getAdditionalInfoExpeditionsPoti(itemId) {
    const url = this._getUrl(`/${itemId}/get-additional-info-poti`);
    const resp = await this._getResource(url);
    return {
      data: resp.results
    };
  }



  static async getExpeditionsKlaipedaUkraineList(params) {
    const { pageSize, urlParam } = this._getPageSizeUrlParamList(params);
    const url = this._getUrl(`/get-expeditions-klaipeda-ukraine${urlParam}`);
    const resp = await this._getResource(url);
    return {
      pageSize: pageSize,
      totalCount: resp.count,
      data: resp.results
    };
  }
  static async getAdditionalInfoExpeditionsKlaipedaUkraine(itemId) {
    const url = this._getUrl(`/${itemId}/get-additional-info-klaipeda-ukraine`);
    const resp = await this._getResource(url);
    return {
      data: resp.results
    };
  }


  static async getExpeditionsKlaipedaLithuaniaList(params) {
    const { pageSize, urlParam } = this._getPageSizeUrlParamList(params);
    const url = this._getUrl(`/get-expeditions-klaipeda-lithuania${urlParam}`);
    const resp = await this._getResource(url);
    return {
      pageSize: pageSize,
      totalCount: resp.count,
      data: resp.results
    };
  }
  static async getAdditionalInfoExpeditionsKlaipedaLithuania(itemId) {
    const url = this._getUrl(`/${itemId}/get-additional-info-klaipeda-lithuania`);
    const resp = await this._getResource(url);
    return {
      data: resp.results
    };
  }


  static async getExpeditionsKlaipedaOthersList(params) {
    const { pageSize, urlParam } = this._getPageSizeUrlParamList(params);
    const url = this._getUrl(`/get-expeditions-klaipeda-others${urlParam}`);
    const resp = await this._getResource(url);
    return {
      pageSize: pageSize,
      totalCount: resp.count,
      data: resp.results
    };
  }
  static async getAdditionalInfoExpeditionsKlaipedaOthers(itemId) {
    const url = this._getUrl(`/${itemId}/get-additional-info-klaipeda-others`);
    const resp = await this._getResource(url);
    return {
      data: resp.results
    };
  }



}


export default ExpeditionDealerService;